import React, { Component } from "react";
//import React, { useState, useEffect } from "react";
import MoreVertIcon from "@material-ui/icons/MoreVert";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Table from "../../components/Table/Table.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import AddIcon from "@material-ui/icons/Add";
import { getCustomer } from "../../graphql/myquereis";
import { getCustomerTeam } from "../../graphql/queries";
import moment from "moment";
import { withApollo } from "react-apollo";
import { flowRight } from "lodash";
import gql from "graphql-tag";
import Context from "../../data/context";
import CloudUploadIcon from "@material-ui/icons/CloudUpload"; //import AWSAppSyncClient from "aws-appsync";
import * as queries from "../../graphql/queries";
import { spinnerService } from "@chevtek/react-spinners";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { connect } from "react-redux";
import Pagination from "../../components/pagination/pagination";
import * as actionTypes from "../../redux/actions";
import { styles } from "../../assets/css/styles.js";
import isEmpty from "lodash/isEmpty";
import DataTable from "../../customers/DataTable.js";
import { myGetCustomerExtended } from "../../data/customQueries.js";
let allVehicles = [];
let vehicleDispData = [];
const heads = [
  {
    id: "id",
    label: "Vehicle ID"
  },
  { id: "make", label: "Make" },
  { id: "model", label: "Model" },
  { id: "vin", label: "VIN" },
  {
    id: "inspections",
    label: "Inspection Due By:"
  },
  { id: "defects", label: "Defects" },
  { id: "edit", label: "Edit" },
  { id: "del", label: "Delete" }
];
class TableList extends Component {
  static contextType = Context;
  constructor(props) {
    super(props);
  }
  state = {
    customer: {},
    vehicles: [],
    vehAdded: false,
    start: 0,
    end: 10,
    nextToken: null,
    newView: false,
    tableData: [],
    registeredInspectionType: ""
  };
  async loadData(user, reload) {
    if (reload === false) {
      spinnerService.show("mySpinner");
    }
    const { client, profile } = this.props;
    let isFetched = false;
    if (user) {
      let custUsername = user.username;
      let userType = null;
      if (
        user !== null &&
        user !== "notFound" &&
        user.signInUserSession.idToken.payload["cognito:groups"] !== undefined
      ) {
        userType = user.signInUserSession.idToken.payload["cognito:groups"][0];
      }
      if (userType === "Dispatchers" || userType === "Technicians") {
        // setIsDisp(true);
        let custTeam = (await client.query({
          query: gql(getCustomerTeam),
          fetchPolicy: `network-only`,
          variables: { id: user.username, limit: 1000 }
        })).data.getCustomerTeam;
        custUsername = custTeam.customer.id;
      }
      let userDetails;
      //   if (profile === undefined || profile === "" || profile === null) {
      const returnData = await client.query({
        // query: gql(getCustomer),
        query: gql(myGetCustomerExtended),
        fetchPolicy: `network-only`,
        variables: {
          id: custUsername
          // limit: 10,
          // nextToken: this.state.nextToken
        }
      });

      isFetched = true;
      userDetails = returnData.data.getCustomer;
      //   }
      //  else userDetails = profile;

      isFetched && this.props.storeProfile(userDetails);
      if (userDetails.vehicles.items !== null) {
        // setVehicleCount(userDetails.vehicles.items.length);
        let index = 0;
        userDetails.vehicles.items.forEach(item => {
          index++;
          let vehDefectCount = 0;
          let redTagCheck = false;
          let dispObj = {
            key: index,
            redTag: false,
            customerVehicleId: item.customerVehicleId,
            VIN: item.VIN,
            id: item.id,
            sort: 0,
            vehCategory:
              item.vehicleType !== null ? item.vehicleType.vehicleCategory : "",
            mainPic: item.mainPic,
            make: item.make,
            model: item.model,
            // history: history,
            deactivateBIT: item.deactivateBIT,
            deactivateDOT: item.deactivateDOT,
            regType: userDetails.registeredInspectionType,
            customer: userDetails.id,
            redTagCounter: 0,
            status: item.vehicleStatus
          };
          if (
            item.nextInspectionDue !== undefined &&
            item.nextInspectionDue !== null
          ) {
            if (item.nextInspectionDue.length > 0) {
              // dispObj.nextInspectionDue = item.nextInspectionDue[0].nextDueDate;
              dispObj.nextInspectionDue = item.nextInspectionDue;
            }
          } else {
            dispObj.nextInspectionDue = "";
          }
          if (userDetails.registeredInspectionType !== "FEDERAL_BIT") {
            if (
              !(
                item.nextInspectionDue === undefined ||
                item.nextInspectionDue === null
              )
            ) {
              if (item.nextInspectionDue.length > 0) {
                dispObj.nextDue = ["", null, undefined].includes(
                  item.nextInspectionDue[0].nextDueDate
                )
                  ? null
                  : item.nextInspectionDue[0].nextDueDate;
              }
            }
          } else if (userDetails.registeredInspectionType === "FEDERAL_BIT") {
            const date1 =
              item.nextInspectionDue && item.nextInspectionDue.length > 0
                ? item.nextInspectionDue[0].nextDueDate
                : null;
            const date2 =
              item.nextInspectionDue && item.nextInspectionDue.length > 1
                ? item.nextInspectionDue[1].nextDueDate
                : null;

            if (
              ["", null, undefined].includes(date1) &&
              ["", null, undefined].includes(date2)
            ) {
              dispObj.nextDue = null;
            } else if (
              ["", null, undefined].includes(date1) &&
              !["", null, undefined].includes(date2)
            ) {
              dispObj.nextDue = date2;
            } else if (
              !["", null, undefined].includes(date1) &&
              ["", null, undefined].includes(date2)
            ) {
              dispObj.nextDue = date1;
            } else if (
              !["", null, undefined].includes(date1) &&
              !["", null, undefined].includes(date2)
            ) {
              if (moment(new Date(date2)).isBefore(new Date(date1))) {
                dispObj.nextDue = date2;
              } else {
                dispObj.nextDue = date1;
              }
            }
          }
          userDetails.defectsByStatus.items.map(defect => {
            if (defect.vehicle !== null) {
              if (defect.vehicleId === item.id) {
                if (defect.redTag === true) {
                  dispObj.redTagCounter++;
                  dispObj.redTag = true;
                }
                vehDefectCount++;
                dispObj.defectStatus = defect.status;
              }
            }
          });
          dispObj.defectCount = vehDefectCount;
          /*
          res.inspectionsByDueDate.items.map(inspection => {
            if (inspection.vehicle !== null) {
              if (inspection.vehicle.id == item.id) {
                dispObj.inspectionDue = true;
                dispObj.nextInspectionDue = inspection.nextInspectionDue;
              }
            }
          });
          */
          vehicleDispData.push(dispObj);
        });
      }
      let tempArr = vehicleDispData.filter(a => a.defectCount > 0);
      tempArr.sort((a, b) => {
        if (a.defectCount < b.defectCount) {
          // sortCounter++;
          // a.sort = sortCounter;
          return 1;
        }
        // b.sort = sortCounter;
        return -1;
      });
      let tempArr1 = tempArr.filter(a => a.redTag);
      tempArr1.sort((a, b) => {
        if (a.redTagCounter < b.redTagCounter) {
          // sortCounter++;
          // a.sort = sortCounter;
          return 1;
        }
        // b.sort = sortCounter;
        return -1;
      });
      let tempArr3 = [...tempArr1, ...tempArr, ...vehicleDispData];
      tempArr3 = new Set(tempArr3);
      tempArr3 = [...tempArr3];
      vehicleDispData = tempArr3;
      this.setState(
        {
          tableData: vehicleDispData,
          newView: true,
          registeredInspectionType: userDetails.registeredInspectionType
        },
        () => {
          vehicleDispData = [];
        }
      );
      if (userDetails) {
        // this.setState({
        //   tableData: returnData.data.getCustomer.vehicles.items
        // });
        this.setState({
          nextToken: userDetails.vehicles.nextToken
        });
        var selectVeh = new Array();

        let i = 0;
        if (userDetails.vehicles.items.length > 0) {
          userDetails.vehicles.items.map(vehItem => {
            if (
              vehItem.inspections !== undefined &&
              vehItem.inspections.items !== undefined &&
              vehItem.inspections.items !== null
            ) {
              var nextDueDate = vehItem.inspections.items.filter(inspItem => {
                const currentDay = new Date();
                const nextDue = new Date(inspItem.nextInspectionDue);
                if (
                  nextDue >= currentDay
                  // nextDue.getDate() - currentDay.getDate() >= 0 &&
                  //nextDue.getMonth() >= currentDay.getMonth() &&
                  // nextDue.getFullYear() >= currentDay.getFullYear()
                ) {
                  return true;
                }
                return false;
              });

              let _nextDueDate = "";
              if (nextDueDate.length > 0)
                _nextDueDate = nextDueDate[0].nextInspectionDue;
              selectVeh[i] = new Array();
              selectVeh[i].push(
                vehItem.id,
                vehItem.customerVehicleId,
                vehItem.make,
                vehItem.model,
                vehItem.VIN,
                vehItem.vehicleStatus,
                "Details",
                "Edit",
                "Del"
              );
              i++;
            } else {
              selectVeh[i] = new Array();
              selectVeh[i].push(
                vehItem.id,
                vehItem.customerVehicleId,
                vehItem.make,
                vehItem.model,
                vehItem.VIN,
                vehItem.vehicleStatus,

                "Details",
                "Edit",
                "Del"
              );
              i++;
            }
          });
        }
        var data = {
          customer: userDetails,
          vehicles: selectVeh
        };
        allVehicles = selectVeh;
        this.props.storeVehicle(data);
        this.setState({
          customer: userDetails,
          vehicles: [...this.state.vehicles, ...selectVeh]
        });
        /**/
      }
    }
    if (reload === false) {
      spinnerService.hide("mySpinner");
    }
  }
  async componentDidMount() {
    const user = this.props.user;
    // const user = await Auth.currentAuthenticatedUser();
    //++++++++++without Redux logic
    await this.loadData(user, false);
    if (
      this.props.location.state !== undefined &&
      this.props.location.state.reload
    ) {
      await this.loadData(user, false);
    }
    /************Redux logic */
    /*
   
    if (this.props.data === undefined || this.props.data.length === 0) {
      await this.loadData(user, false);
    } else if (this.props.data.vehicles.length === 0) {
      await this.loadData(user, false);
    } else {
      allVehicles = this.props.data.vehicles;
      this.setState({
        customer: this.props.data.customer,
        vehicles: this.props.data.vehicles
      });
      //await this.loadData(user, true);
    }
    */
    /************Redux logic */
  }
  componentWillUnmount() {
    this.setState({
      tableData: []
    });
  }
  async next() {
    const user = this.props.user;

    let { limit, start, end, nextToken, vehicles } = this.state;
    if (end < vehicles.length) {
      this.setState({ start: end, end: end + 10 });
    } else {
      if (nextToken) {
        await this.loadData(user, false);
        this.setState({ start: end, end: end + 10 });
      }
    }
  }
  async previous() {
    let { start, end } = this.state;

    if (start - 10 <= 0) {
      this.setState({ start: 0, end: 10 });
    } else {
      this.setState({ start: start - 10, end: end - 10 });
    }
  }
  changePage = i => {
    let start = i * 10 - 10,
      end = i * 10;
    this.setState({ start, end });
  };
  filterDriverNamesHandler(e) {
    //
    let filteredVehicles = vehicleDispData.filter(o => {
      return o.customerVehicleId.toLowerCase().includes(e.toLowerCase());
    });

    this.setState({ tableData: filteredVehicles });
  }
  render() {
    const { classes, client, user } = this.props;
    const {
      customer,
      vehicles,
      start,
      end,
      registeredInspectionType
    } = this.state;

    return (
      <React.Fragment>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            {/* <Router> */}
            <div>
              <Button
                variant="contained"
                // component={Link}
                onClick={() => {
                  this.props.history.push(`/company/add-vehicle`, {
                    registeredInspectionType
                  });
                }}
                // to={{
                //   pathname: "/company/add-vehicle",
                //   client: { client },
                //   registeredInspectionType: { registeredInspectionType }
                // }}
                className={classes.blackButton}
              >
                <AddIcon />
                Add Vehicle
              </Button>
              <Button
                variant="contained"
                className={classes.blackButton}
                style={{ marginLeft: 10, display: "none" }}
              >
                <CloudUploadIcon />
                Bulk Upload
              </Button>
            </div>
            {/* </Router> */}
            <div style={{ float: "left", padding: "10px" }}></div>
            {/* {this.state.newView && (
              <div
                onClick={() =>
                  this.setState({
                    newView: false
                  })
                }
              >
                {" "}
                Old View{" "}
              </div>
            )}
            {!this.state.newView && (
              <div
                onClick={() =>
                  this.setState({
                    newView: true
                  })
                }
              >
                {" "}
                New View{" "}
              </div>
            )} */}
            <Card>
              <CardHeader className={classes.cardHeader}>
                <h4 className={classes.cardTitleWhite}>
                  Registered Vehicles for {customer.companyName}
                </h4>
                <p className={classes.cardCategoryWhite}>
                  List of vehicles maintained at CalBit Portal
                </p>
              </CardHeader>
              <CardBody style={{ minHeight: 585 }}>
                {/* <div>
                  <input
                    type="text"
                    className="form-control"
                    onChange={e =>
                      this.filterDriverNamesHandler(e.target.value)
                    }
                    placeholder="Search Vehicle By ID"
                    style={{ height: 35, width: 250 }}
                  />
                </div> */}
                <React.Fragment>
                  {this.state.newView ? (
                    <DataTable
                      rows={this.state.tableData}
                      heads={heads}
                      table="general"
                      client={client}
                      loadData={() => this.loadData(user, true)}
                      // reload={() => this.componentDidMount()}
                    />
                  ) : (
                    <React.Fragment>
                      {vehicles.length === 0 ? (
                        <h5 style={{ marginTop: 10 }}>No Data</h5>
                      ) : (
                        this.state.vehicles !== null && (
                          <Table
                            tableHeaderColor="primary"
                            tableHead={[
                              "Vehicle ID",
                              "Make",
                              "Model",
                              "VIN",
                              "Status",
                              "",
                              "",
                              ""
                            ]}
                            tableData={
                              vehicles.length > 0
                                ? vehicles.slice(start, end)
                                : []
                            }
                            client={client}
                            loadData={() => this.loadData(user, true)}
                          />
                        )
                      )}
                      {vehicles.length > 0 && (
                        <div
                          style={{
                            marginTop: 20,
                            fontSize: 14,
                            fontWeight: "bolder",
                            color: "blue"
                          }}
                        >
                          <span
                            style={{
                              textDecoration: "underline",
                              margin: 5,
                              cursor: "pointer"
                            }}
                            onClick={() => this.previous()}
                          >
                            Previous
                          </span>
                          |
                          <span
                            style={{
                              textDecoration: "underline",
                              margin: 5,
                              cursor: "pointer"
                            }}
                            onClick={() => this.next()}
                          >
                            Next
                          </span>
                        </div>
                      )}
                    </React.Fragment>
                  )}
                </React.Fragment>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        {/* {
          vehicles.length > 10 && (
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <Pagination
                  onPageSelect={this.changePage}
                  start={start}
                  data={vehicles}
                />
              </GridItem>
            </GridContainer>
          )
        } */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    loading: state.vehicles.loading,
    data: state.vehicles.data,
    profile: state.config.profile
  };
};
const mapDispatchToProps = dispatch => {
  return {
    // addCounter: (id) => dispatch({type:actionTypes.Add_Counter, val:id}),
    storeVehicle: data => dispatch(actionTypes.storeVehicle(data)),
    storeProfile: data => dispatch(actionTypes.storeProfile(data)),

    // fetchInspection: () => dispatch(actionTypes.fetchInspection_AC()),
    requestVehicle: () => dispatch(actionTypes.requestVehicle())
  };
};
export default TableList = connect(
  mapStateToProps,
  mapDispatchToProps
)(flowRight(withApollo)(withStyles(styles)(TableList)));



// WEBPACK FOOTER //
// ./src/views/Company/Setup.jsx